import { getTemperature } from '../../../../helper/temperature';

export function P00058SeuilTemperatureFiltration2424() {
  let r = [];

  for (let i = 25; i <= 30; i++) {
    r.push({
      ref: i,
      label: getTemperature(i, 0),
    });
  }

  return r;
}
